module.exports = __webpack_public_path__ + "static/img/14.4f04053.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/zh/14.png
// module id = wenI
// module chunks = 0